// Etiquetas y tonos de status alineados con InternalDocument::STATUSES en backend.
export const STATUS_LABEL = {
  draft: "Borrador",
  published: "Publicado",
  archived: "Archivado",
};

export const STATUS_TONE = {
  draft: "warning",
  published: "success",
  archived: "neutral",
};

export const EXT_COLORS = {
  PDF: ["var(--kr-status-danger-bg)", "var(--kr-danger-700)"],
  JPG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  JPEG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  PNG: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  DOC: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  DOCX: ["var(--kr-status-info-bg)", "var(--kr-info-700)"],
  XLS: ["var(--kr-status-success-bg)", "var(--kr-success-700)"],
  XLSX: ["var(--kr-status-success-bg)", "var(--kr-success-700)"],
};

export const TEXTAREA_STYLE = {
  width: "100%",
  border: "1px solid var(--kr-border)",
  borderRadius: 6,
  padding: 10,
  fontSize: 13,
  fontFamily: "var(--kr-font-sans)",
  outline: "none",
  resize: "vertical",
  color: "var(--kr-fg-strong)",
};
